export default {"src":"/_next/static/media/likeBox.c211adbf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};